<template>
    <div>
        <h5>Stickers</h5>
        <div class="mb-3 mt-3">
            <div v-for="(sticker, index) in stickers" class="form-group input-group mb-4">
                <v-select v-model="sticker_model[index]" :options="sticker_list" label="name" style="width:250px;" @input="change_array(sticker.pivot.id)">
                    <template v-slot:option="option">
                        <div class="d-flex align-items-center select-option">
                            <div class="select-sticker mr-2">
                                <img :src="option.images.svg" class="w-100" />
                            </div>
                            <div>
                                {{option.name }}
                            </div>
                        </div>
                    </template>
                </v-select>
                <select class="form-control ml-2" v-for="(preset_type, subindex) in preset_sticker_types" v-model="sale_send[index].pivot.preset[subindex].id" @change="change_array(sticker.pivot.id)">
                    <option :value="null" disabled>{{preset_type.name}}</option>
                    <option v-for="preset_sticker in preset_stickers" v-if="preset_sticker.type.id == preset_type.id" :value="preset_sticker.id">
                        {{ preset_sticker.name }}
                    </option>
                </select>
                <select class="form-control ml-2" v-model="sale_send[index].pivot.location.id" @change="change_array(sticker.pivot.id)">
                    <option :value="null" disabled>Location</option>
                    <option v-for="location in locations" :value="location.id">{{ location.name }}</option>
                </select>
                <select class="form-control ml-2" v-model="sale_send[index].pivot.group.id" @change="change_array(sticker.pivot.id)">
                    <option :value="null">All products</option>
                    <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
                </select>
                <button class="btn btn-danger ml-2" @click="delete_sticker(index, sticker.pivot.id)"><i class="far fa-trash-alt text-white"></i></button>
            </div>
            <button class="btn btn-info mt-2 btn-sm" @click="add_sticker()"><i class="fas fa-plus"></i>&nbsp; Add sticker</button>
        </div>
        <div>
            <button class="btn btn-danger mr-1" @click="closeSection"><i class="far fa-times-circle"></i>&nbsp; Close</button>
            <button class="btn btn-primary mr-1" @click="save()"><i class="far fa-save"></i>&nbsp; Save</button>
            <button class="btn btn-success" @click="save('close')"><i class="fas fa-save"></i>&nbsp; Save &amp; close</button>
        </div>
        <loader :loading="loading"></loader>
    </div>
</template> 

<script>

import loader from './loader.vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {

    components: {
        loader,
        vSelect
    },

    data() {
        return {
            stickers: [],
            sticker_list: [],
            sticker_model: [],
            sale_send: [],
            preset_sticker_types: {},
            preset_stickers: {},
            groups: {},
            locations: {},

            load_count: 0,
            changed: [],
            deleted: [],
            axios_array: [],

            loading: true,
        };
    },

    props: {
        sale: Object,
    },

    mounted(){
        this.sale_send = this.sale.stickers;
        this.stickers = this.sale.stickers;

        this.update_stickers();
         
        history.pushState({page: 0}, "", window.location.pathname + "?page=stickers");  
        this.on_load();
    },

    methods: {
        save(close) {
            this.loading_count();
            if(this.load_count > 0){
                this.loading = true;
            } else if(close){
                this.closeSection();
            }
            if(this.deleted.length > 0){
                for(let del in this.deleted){
                    this.axios_array.push(axios.delete('/sales/' + this.sale.id + '/stickers/' + this.deleted[del]));
                }
            }
            for(let sticker in this.sale_send){
                if(this.changed.includes(this.sale_send[sticker].pivot.id) && this.sale_send[sticker].pivot.id){
                    this.axios_array.push(axios.patch('/sales/' + this.sale.id + '/stickers/' + this.sale_send[sticker].pivot.id,{
                        sticker_id: this.sticker_model[sticker].id, 
                        location_id: this.sale_send[sticker].pivot.location.id,
                        group_id: this.sale_send[sticker].pivot.group.id,
                        preset_sticker_location_id: this.sale_send[sticker].pivot.preset[0].id,
                        preset_sticker_size_id: this.sale_send[sticker].pivot.preset[1].id,
                    }));
                } else if(!this.sale_send[sticker].pivot.id){
                    this.axios_array.push(axios.post('/sales/' + this.sale.id + '/stickers', 
                    {
                        sticker_id: this.sticker_model[sticker].id, 
                        location_id: this.sale_send[sticker].pivot.location.id,
                        group_id: this.sale_send[sticker].pivot.group.id,
                        preset_sticker_location_id: this.sale_send[sticker].pivot.preset[0].id,
                        preset_sticker_size_id: this.sale_send[sticker].pivot.preset[1].id,
                    }));
                }
            }
            axios.all(this.axios_array)            
            .then(function (responses){   
                if(responses.length > 0){   
                    axios.get('/sales/' + this.sale.id)
                    .then(function (response) {
                        this.sale_send = response.data.sale.stickers; 
                        this.update_stickers();                   
                        this.check_load(close);               
                    }.bind(this))
                    .catch(function (error) {
                        alert(error);
                    })                
                }
            }.bind(this));
        },
        add_sticker(){
            let presets = [];
            for(let preset in this.preset_sticker_types){
                presets.push({id:null});       
            }
            this.sale_send.push(
                {
                    images: this.sticker_list[0].images,
                    name: this.sticker_list[0].name,
                    id: this.sticker_list[0].id,
                    pivot:{
                        group: {id: null},
                        location: {id: null},
                        preset: presets,
                    }
                }
            );
            this.sticker_model.push(
                {
                    images: this.sticker_list[0].images,
                    name: this.sticker_list[0].name,
                    id: this.sticker_list[0].id,
                    pivot:{
                        group: {id: null},
                        location: {id: null},
                        preset: presets,
                    }
                }
            );
        },
        on_load(){
            let loadcount = 0;
            axios.get('/media-centre/stickers/list')
            .then(function (response) {    
                this.check_on_load(loadcount++);
                this.sticker_list = response.data.stickers.data;   
                axios.get('/preset-sticker-types/list')
                .then(function (response) {
                    this.check_on_load(loadcount++);
                    this.preset_sticker_types = response.data.preset_sticker_types;
                    axios.get('/preset-stickers/list')
                    .then(function (response) {
                        this.check_on_load(loadcount++);
                        this.preset_stickers = response.data.preset_stickers;
                        axios.get('/groups/list')
                        .then(function (response) {
                            this.check_on_load(loadcount++);
                            this.groups = response.data.groups;
                            axios.get('/locations/list')
                            .then(function (response) {
                                this.check_on_load(loadcount++);               
                                this.locations = response.data.locations;
                            }.bind(this))
                            .catch(function (error) {
                                // handle error
                                alert(error);
                            })
                        }.bind(this))
                        .catch(function (error) {
                            // handle error
                            alert(error);
                        })
                    }.bind(this))
                    .catch(function (error) {
                        // handle error
                        alert(error);
                    })
                }.bind(this))
                .catch(function (error) {
                    // handle error
                    alert(error);
                })             
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
            })                                                
        },
        change_array(id){
            if(id){
                if(!this.changed.includes(id)){
                    this.changed.push(id);
                }
            }
        },
        delete_sticker(index, id){
            this.sale_send.splice(index, 1); 
            this.stickers.splice(index, 1); 
            this.sticker_model.splice(index, 1);  
            if(id){
                this.deleted.push(id);
            }
        },
        loading_count(){
            let loadCount = this.changed.length + this.deleted.length;
            for(let message in this.sale_send){
                if(!this.sale_send[message].pivot.id){
                    loadCount++;
                }
            }
            this.load_count = loadCount;
        },
        check_load(close){
            this.loading = false;
            this.changed = [];
            this.deleted = [];
            this.axios_array = [];
            if(close == 'close'){
                this.closeSection();
            }
        },
        update_stickers(){  
            this.sticker_model = [];
            for(let sticker in this.sale_send){
                if(this.sale_send[sticker].pivot.group == null){
                    Vue.set( this.sale_send[sticker].pivot, 'group', {'id':null});
                }
                this.sticker_model.push(
                    this.sale_send[sticker],
                );
            }            
        },
        check_on_load(loadcount){
            if(loadcount == 4){
                this.loading = false;
            }
        },
        closeSection (event) {
            history.pushState({page: 0}, "", window.location.pathname); 
            this.$emit('closeChild', false);
        },
    },
};
</script>